import config from 'config/config';

const PREFIX = `ITERIO_APP_${config.environment}_`;
const storage = window.localStorage;

export const CONNECTION_STATUS = 'CONNECTION_STATUS';

const jsonParse = (str) => {
  try {
    return JSON.parse(str);
  } catch (ex) {
    console.error(ex);
    return false;
  }
};

export const setItem = (name, item) => {
  try {
    storage.setItem(PREFIX + name, item);
  } catch (error) {
    console.log(error);
  }
};

export const getItem = (name) => {
  try {
    return storage.getItem(PREFIX + name);
  } catch (error) {
    console.log(error);
  }
};

export const removeItem = (name) => {
  try {
    storage.removeItem(PREFIX + name);
  } catch (error) {
    console.log(error);
  }
};

export const setJsonItem = (name, item) => {
  try {
    const stringifyItem = JSON.stringify(item);
    setItem(name, stringifyItem);
  } catch (error) {
    console.log(error);
  }
};

export const getJsonItem = (name) => {
  try {
    const item = getItem(name);
    return jsonParse(item);
  } catch (error) {
    console.log(error);
  }
};

export const getArray = (name) => {
  const item = getJsonItem(name);
  return Array.isArray(item) ? item : [];
};

export const pushItem = (name, item) => {
  try {
    const allItems = getArray(name);
    allItems.push(item);
    setJsonItem(name, allItems);
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/utils/storageUtils.js